<template> 
  <div :class="!flight ? 'h-100 d-flex align-items-center' : ''">
    <div 
      v-if="flight"
      class="fw-bold mb-2"
    >
      {{ direction === 'O' ? 'Hinflug' : 'Rückflug' }}
    </div>

    <div 
      v-if="flight"
      class="h-100 d-flex"
    >
      <!--main flight-->
      <div v-if="!outboundFlight?.stopDeparture && !inboundFlight?.stopArrival">
        <FlightInfo
          :arrival="inboundFlight?.arrival"
          :departure="outboundFlight?.departure"
          :flight="outboundFlight?.mainFlight"
          :has-feeder="false"
          :rnf-info-text="rnfInfoText"
        />
      </div>

      <!--main flight + feeder flight-->
      <div v-if="!!outboundFlight?.feederFlight && !!outboundFlight?.stopDeparture && !!inboundFlight?.stopArrival">
        <FlightInfo
          :arrival="inboundFlight.stopArrival"
          :departure="outboundFlight?.departure"
          :flight="direction === 'O' ? outboundFlight.feederFlight : outboundFlight?.mainFlight"
          :has-feeder="true"
          :is-outbound-flight="true"
          :rnf-info-text="direction === 'O' ? rnfInfoText : ''"
        />

        <FlightInfo
          :departure="outboundFlight.stopDeparture"
          :arrival="inboundFlight.arrival"
          :flight="direction === 'O' ? outboundFlight.mainFlight : outboundFlight.feederFlight"
          :has-feeder="true"
          :is-outbound-flight="false"
          :rnf-info-text="direction === 'O' ? '' : rnfInfoText"
        />
      </div>
    </div>

    <div 
      v-else 
      class="w-100 fs-16 text-center color-sachlich-grey"
    >
      {{ message }}
    </div>
  </div>
</template>

<script lang="ts">
import { useDetailsStore, useFlexFlightStore, useFlightStore } from '@/store'
import { IOutboundInboundFlexFlight } from '@/store/details/flex-flight/interfaces'
import { IExpinetFlightType, IExpinetFlightTypeMap } from '@/store/details/flight/interfaces'
import { mapState } from 'pinia'
import { PropType, defineComponent } from 'vue'
import FlightInfo from './FlightInfo.vue'

export default defineComponent({
  components: { FlightInfo },

  props: {
    flight: {
      type: Object as PropType<IExpinetFlightType | IExpinetFlightTypeMap | IOutboundInboundFlexFlight | null>,
      default: null,
    },
    message: { type: String, default: null },
    direction: { type: String, default: null },
    railDirection: { type: String, default: null },
  },

  computed: {
    ...mapState(useFlexFlightStore, {
      flexFlightServiceIncluded: store => store.serviceIncluded,
    }),
    ...mapState(useFlightStore, {
      flightServiceIncluded: store => store.serviceIncluded,
    }),
    ...mapState(useDetailsStore, {
      transportation: store => store.transportation,
    }),

    rnfInfoText() {
      const usedFlightStore =
        this.transportation === 'Flug' ? this.flightServiceIncluded : this.flexFlightServiceIncluded

      switch(this.direction) {
        case 'O':
          return usedFlightStore.outbound
        case 'I':
          return usedFlightStore.inbound
        default:
          return ''
      }
    },

    inboundFlight() {
      if (this.flight && 'stopArrival' in this.flight) {
        return this.flight
      }

      if (this.flight && 'inboundFlight' in this.flight && this.flight.inboundFlight) {
        return this.flight.inboundFlight
      }

      return null
    },

    outboundFlight() {
      if (this.flight && 'stopArrival' in this.flight) {
        return this.flight
      }

      if (this.flight && 'outboundFlight' in this.flight && this.flight.outboundFlight) {
        return this.flight.outboundFlight
      }

      return null
    },
  },
})
</script>
